import {DialogController} from 'aurelia-dialog';
import {inject} from "aurelia-framework";
import {FormField} from "../../../form/object/form-field";

@inject(
    DialogController
)
export class AiImageTaggingView {
    constructor(
        dialogController
    ) {
        this.dialogController = dialogController;
    }

    async activate(context)
    {
        const dummyFormService = {
            change: () => {}
        };

        this.field = new FormField(
            dummyFormService,
            {
                'label': 'artificial-intelligence.integration.media-database.artificialIntelligenceTagsValueSettingType',
                'type': 'choice',
                'set': 'media_database_tags_value_setting_types',
                'default': 'append',
                'multiple': false,
                'required': true
            },
            'artificialIntelligenceTagsValueSettingType',
            'append'
        );

        this.title   = context.title;
        this.onSave  = context.onSave;
        this.loading = false;
    }

    async ok()
    {
        this.loading = true;

        return this.onSave(this.field.getValue()).then(
            (response) => {
                // Don't set loading to false, because dialog will be closed anyway.
                // If you set loading = false here, user will see blink of dialog controls.
                //this.loading = false;

                return Promise.resolve(this.dialogController.ok())
            }
        ).catch(
            (error) => {
                this.loading = false;

                throw error;
            }
        );
    }
}
